<template>
  <v-card class="px-0 mx-5 rounded-lg">
    <v-card-title>
      <div class="card-icon">
        <v-icon>person_pin</v-icon>
      </div>
      <h4 class="title">新增场景模型</h4>
    </v-card-title>
    <v-card-text style="padding-bottom: 26px">
      <v-form class="px-16" ref="form" v-model="valid">
        <v-select
          v-model="form.course"
          :items="courseList"
          color="#4caf50"
          item-text="name"
          item-value="_id"
          label="课程 *"
          :rules="[(v) => !!v || '课程不能为空']"
          :required="true"
          @change="filterProject"
        ></v-select>
        <v-select
          v-model="form.project"
          :items="projectList"
          color="#4caf50"
          item-text="name"
          item-value="_id"
          label="项目 *"
          :rules="[(v) => !!v || '项目不能为空']"
          :required="true"
          :disabled="projectDisabled"
        ></v-select>
        <v-text-field
          v-model="form.name"
          color="#4caf50"
          label="场景名称 *"
          :rules="[(v) => !!v || '场景名称不能为空']"
          :required="true"
        ></v-text-field>
        <v-text-field
          v-model="sceneMod"
          color="#4caf50"
          label="选择场景模型"
          append-icon="playlist_add_check"
          @click.native="handleSceneSelect()"
        ></v-text-field>
        <div class="md-layout">
          <div
            class="md-layout-item md-size-20"
            v-for="modelResource in form.resourceList"
            :key="modelResource._id"
          >
            <image-card class="img-card" header-animation="true">
              <img
                class="img"
                slot="imageHeader"
                :src="modelResource.model_image"
              />
              <template slot="footer">
                <div class="stats">{{ modelResource.model_name }}</div>
              </template>
            </image-card>
          </div>
        </div>
        <v-file-input
          truncate-length="15"
          label="模型GLTF文件上传"
          color="#4caf50"
          @change="(f) => (form.mod_file = f)"
          show-size
        >
        </v-file-input>
        <v-textarea
          v-model="form.remark"
          color="#4caf50"
          label="备注"
        ></v-textarea>
        <div class="text-right">
          <v-btn class="mr-4" color="success" @click="confirm">确 定</v-btn>
          <v-btn color="success" @click="back">返 回</v-btn>
        </div>
      </v-form>
    </v-card-text>
    <v-dialog v-model="showSelectDialog" hide-overlay max-width="80%">
      <v-card>
        <SceneSelect
          :formData="actionFormData"
          @handleCancel="handleCancel"
          @handleSubmit="handleSubmit"
        />
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { Collapse, ProductCard, ImageCard } from "@/components";
import SceneSelect from "./Action/SceneSelect";
import api from "@/../common/js/api";
import configApi from "@/common/config/api";
import {
  addSceneModelDefinition,
  updateSceneModelDefinition,
} from "@/api/modelDefinition/sceneModelDefinition";
import { listCourse } from "@/api/course";
import { listProject } from "@/api/project";
export default {
  data() {
    return {
      valid: false,
      course: "",
      sceneMod: "",
      showSelectDialog: false,
      scene1: "./img/scene1.jpeg",
      scene2: "./img/scene2.jpeg",
      scene3: "./img/scene3.jpeg",
      scene4: "./img/scene4.jpeg",
      scene5: "./img/scene5.jpeg",
      actionFormData: {},
      showAddDialog: false,
      actionFormData: {},
      handleIndex: -1,
      tableData: [],
      form: {},
      courseList: [],
      projectList: [],
      scene_obj: {},
      projectDisabled: true,
    };
  },
  components: {
    Collapse,
    ProductCard,
    SceneSelect,
    ImageCard,
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const courseResult = await listCourse();
      const projectResult = await listProject();
      if (courseResult.code == 200) {
        this.courseList = courseResult.data.rows;
      }
      if (projectResult.code == 200) {
        this.projectList = projectResult.data.rows;
      }
      if (this.$route.query._id) {
        this.form = this.$route.query;
        this.sceneMod = this.form.resourceList
          .map((item) => item.model_name)
          .join(",");
      }
    },
    async filterProject(item) {
      const projectResult = await listProject({
        course: item._id,
        perPage: 500,
      });
      if (projectResult.code == 200) {
        this.projectList = projectResult.data.rows;
        this.projectDisabled = false;
      }
    },
    async confirm() {
      const uploadFile = (fieldName, file) => {
        const formData = new FormData();
        formData.append(fieldName, file);
        return api.$axios(configApi.upload(formData));
      };
      if (this.form.mod_file) {
        this.uploadProgress = "上传模型文件...";
        this.form.modFile = (
          await uploadFile("modelFile", this.form.mod_file)
        ).data.data.url;
      }
      const result = this.$route.query.name
        ? await updateSceneModelDefinition(this.form)
        : await addSceneModelDefinition(this.form);
      if (result.code == 200) {
        this.$notify({
          timeout: 1500,
          message: "操作成功！",
          icon: "add_alert",
          horizontalAlign: "center",
          verticalAlign: "bottom",
          type: "success",
        });
        this.back();
      } else {
        this.$notify({
          timeout: 1500,
          message: "操作失败",
          horizontalAlign: "center",
          verticalAlign: "bottom",
          type: "warning",
        });
      }
    },
    back() {
      this.$router.push({ path: "./scenemod" });
    },
    handleSceneSelect() {
      this.showSelectDialog = true;
    },
    handleCancel() {
      this.showSelectDialog = false;
    },
    handleSubmit(checkList) {
      this.form.resourceList = checkList;
      this.sceneMod = checkList.map((item) => item.model_name).join(",");
      this.showSelectDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.card-icon {
  border-radius: 3px;
  background: linear-gradient(60deg, #66bb6a, #43a047);
  padding: 10px;
  margin-top: -50px;
  margin-right: 15px;
  float: left;
}
.card-icon i {
  width: 33px;
  height: 33px;
  text-align: center;
  line-height: 33px;
  color: #fff;
}
::v-deep .v-text-field__details {
  overflow: unset;
}
</style>
